export const Clients = {
  Redners: "323",
  Mosers: "116"
}